module.exports = __webpack_public_path__ + "fonts/beb88be6-2a60-46fe-914f-6892b3ae46ce.b13c666.ttf";